import {App} from '@inertiajs/inertia-svelte'
import {InertiaProgress} from '@inertiajs/progress'

InertiaProgress.init({
	color: 'black',
	showSpinner: false,
});

const el = document.getElementById('app');

new App({
	target: el,
	props: {
		initialPage: JSON.parse(el.dataset.page),
		resolveComponent: (name) => {
			// We are using just one main page -> change to ${name} when expanding
			return import(`@/pages/Main.svelte`); // import(`@/pages/${name}.svelte`);
		}
	},
});
